import React from "react";
import { FormGroup, Label, Input } from "reactstrap";
import DatePicker from "react-datepicker";
import { ParamType } from "../types";
import style from "./styles.module.scss";
import { toDateTime, toFormatDate } from "../../../../utils";
import { NumberFormatInput } from "../../../NumberFormatInput/NumberFormatInput";

const Parameter = ({
  ParameterType,
  ParameterName,
  ParameterFriendlyName,
  ParameterInitValue,
  ParameterIsMandatory,
  onChange,
  error,
  value,
}) => {
  const paramValue = value == undefined ? ParameterInitValue : value;

  const handleOnChange = (nextValue) => {
    onChange(ParameterName, nextValue);
  };

  return (
    <FormGroup>
      {ParameterIsMandatory ? (
        <Label className={style.labelReq}>
          {ParameterFriendlyName}
          {" (*) "}
        </Label>
      ) : (
        <Label>{ParameterFriendlyName}</Label>
      )}
      {ParameterType === ParamType.Character && (
        <ParamTextField value={paramValue} invalid={!!error} onChange={handleOnChange} />
      )}
      {ParameterType === ParamType.Numeric && (
        <ParamNumericField value={paramValue} invalid={!!error} onChange={handleOnChange} />
      )}
      {ParameterType === ParamType.Date && (
        <ParamDateField value={paramValue} invalid={!!error} onChange={handleOnChange} />
      )}
      {!!error && <div className="invalid-feedback d-block">{error}</div>}
    </FormGroup>
  );
};

const ParamDateField = ({ value, invalid, onChange }) => {
  let showDate = value && value !== "0000-00-00" ? toDateTime(value) : undefined;

  if (showDate == "Invalid Date") {
    showDate = undefined;
  }

  return (
    <DatePicker
      selected={showDate}
      onChange={(date) => onChange(toFormatDate(date))}
      dateFormat="dd-MM-yyyy"
      customInput={<Input invalid={invalid} />}
    />
  );
};
const ParamNumericField = ({ value, invalid, onChange, dataTypeDecimalName, decimalScale }) => (
  <NumberFormatInput
    type="text"
    customInput={Input}
    value={value}
    invalid={invalid}
    onValueChange={(e) => onChange(e.value)}
    dataTypeDecimalName={dataTypeDecimalName}
    decimalScale={decimalScale}
  />
);

const ParamTextField = ({ value, invalid, onChange }) => (
  <Input type="text" value={value} invalid={invalid} onChange={(e) => onChange(e.target.value)} />
);

export default Parameter;
